import DashboardCard from '@/components/dashboard/dashboard-card'
import { DashboardShell } from '@/components/dashboard/dashboard-shell'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { createFileRoute, Link } from '@tanstack/react-router'
import { Bell, Building2, Clock, Database, FileText, MapPin, Users } from 'lucide-react'

export const Route = createFileRoute('/dashboard/admin/super_admin/')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <DashboardShell>
      <div className="flex flex-col gap-4">
        <h1 className="text-3xl font-bold tracking-tight">Super Admin Dashboard</h1>

        <div className="grid gap-4 md:grid-cols-2">
          <DashboardCard
            description="Manage Organizations"
            title="Organizations"
            topRight={
              <Badge variant="outline" className="flex gap-1 rounded-lg text-xs">
                <Building2 className="size-3" />
              </Badge>
            }
            footer={
              <div className="flex flex-col w-full gap-y-2">
                <div className="text-muted-foreground">
                  View and manage all organizations in the system
                </div>
                <Button className="w-full cursor-pointer" asChild>
                  <Link to="/dashboard/admin/super_admin/organizations">Manage Organizations</Link>
                </Button>
              </div>
            }
          />

          <DashboardCard
            description="Manage Users"
            title="Users"
            topRight={
              <Badge variant="outline" className="flex gap-1 rounded-lg text-xs">
                <Users className="size-3" />
              </Badge>
            }
            footer={
              <div className="flex flex-col w-full gap-y-2">
                <div className="text-muted-foreground">
                  Manage user roles and organization assignments
                </div>
                <Button className="w-full cursor-pointer" asChild>
                  <Link to="/dashboard/admin/super_admin/users">Manage Users</Link>
                </Button>
              </div>
            }
          />

          <DashboardCard
            description="Manage Employees"
            title="Employees"
            topRight={
              <Badge variant="outline" className="flex gap-1 rounded-lg text-xs">
                <Users className="size-3" />
              </Badge>
            }
            footer={
              <div className="flex flex-col w-full gap-y-2">
                <div className="text-muted-foreground">
                  Manage employee roles and organization assignments
                </div>
                <Button className="w-full cursor-pointer" asChild>
                  <Link to="/dashboard/admin/super_admin/employees">Manage Employees</Link>
                </Button>
              </div>
            }
          />

          <DashboardCard
            description="View active employee billing reports by organization"
            title="Billing"
            topRight={
              <Badge variant="outline" className="flex gap-1 rounded-lg text-xs">
                <FileText className="size-3" />
              </Badge>
            }
            footer={
              <div className="flex flex-col w-full gap-y-2">
                <div className="text-muted-foreground">
                  View and export billable employee lists by organization
                </div>
                <Button className="w-full cursor-pointer" asChild>
                  <Link to="/dashboard/admin/super_admin/billing">View Billing</Link>
                </Button>
              </div>
            }
          />

          <DashboardCard
            description="Seed IE298 Organization Data"
            title="IE298 Seed Migration"
            topRight={
              <Badge variant="outline" className="flex gap-1 rounded-lg text-xs">
                <Database className="size-3" />
              </Badge>
            }
            footer={
              <div className="flex flex-col w-full gap-y-2">
                <div className="text-muted-foreground">
                  Seed calendar, clients, employees, and settings for IE298 organization
                </div>
                <Button className="w-full cursor-pointer" asChild>
                  <Link to="/dashboard/admin/super_admin/seed-ie298">Seed IE298 Data</Link>
                </Button>
              </div>
            }
          />

          <DashboardCard
            description="Employee Clock In/Out Analytics"
            title="Clock In/Out Stats"
            topRight={
              <Badge variant="outline" className="flex gap-1 rounded-lg text-xs">
                <Clock className="size-3" />
              </Badge>
            }
            footer={
              <div className="flex flex-col w-full gap-y-2">
                <div className="text-muted-foreground">
                  View analytics on employee clock in and clock out times
                </div>
                <Button className="w-full cursor-pointer" asChild>
                  <Link to="/dashboard/admin/super_admin/clock-stats">View Clock Stats</Link>
                </Button>
              </div>
            }
          />

          <DashboardCard
            description="Manage users who can spoof location on employee dashboard"
            title="Location Spoof Whitelist"
            topRight={
              <Badge variant="outline" className="flex gap-1 rounded-lg text-xs">
                <MapPin className="size-3" />
              </Badge>
            }
            footer={
              <div className="flex flex-col w-full gap-y-2">
                <div className="text-muted-foreground">
                  Add or remove users who can select a default location for clock in/out
                </div>
                <Button className="w-full cursor-pointer" asChild>
                  <Link to="/dashboard/admin/super_admin/location-spoof-whitelist">
                    Manage Whitelist
                  </Link>
                </Button>
              </div>
            }
          />

          <DashboardCard
            description="Debug scheduled missing clock-in notifications"
            title="Notifications Debug"
            topRight={
              <Badge variant="outline" className="flex gap-1 rounded-lg text-xs">
                <Bell className="size-3" />
              </Badge>
            }
            footer={
              <div className="flex flex-col w-full gap-y-2">
                <div className="text-muted-foreground">
                  Test notification scheduling, queueing, and delivery (super admins only)
                </div>
                <Button className="w-full cursor-pointer" asChild>
                  <Link to="/dashboard/admin/super_admin/notifications-debug">
                    Open Notifications Debug
                  </Link>
                </Button>
              </div>
            }
          />
        </div>
      </div>
    </DashboardShell>
  )
}
